module.exports = __webpack_public_path__ + "464dacc1a19a935f1cf1847772677917.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/modals/confirm-delete/confirm-delete.html
// module id = 1153
// module chunks = 0